import AlertLevel from "../../../models/alert";
import AlertModal from "../../Shared/AlertModal/AlertModal";
import { ReactNode } from "react";

type PostSaveInfoModalProps = {
  show?: boolean;
  message?: ReactNode;
  onClose: () => void;
};

const PostSaveInfoModal = ({
  show,
  message,
  onClose,
}: PostSaveInfoModalProps) => {
  return (
    <AlertModal show={show} onClose={onClose} level={AlertLevel.Info}>
      <p>{message}</p>
    </AlertModal>
  );
};

export default PostSaveInfoModal;
